module.exports = __webpack_public_path__ + "static/media/k400at8000056_trip.fc37ad85.jpg";